import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useBibliotecaContext } from "../../context/BibliotecaContext";

export function FederalFilter() {
    const { t } = useTranslation();
    const { impostosData, impostosSelecionados, setImpostosSelecionados } = useBibliotecaContext();

    const options = impostosData
        ? impostosData.map((imposto) => ({
            label: `${imposto.nome}`,
            value: imposto.areaatuacao_id,
        }))
        : [];

    const selectAllOption = { label: "Todos - Selecionar todos", value: "*" };
    
    const allOptions = [selectAllOption, ...options];

    let valueParaOSelect;
    if (impostosSelecionados.includes("*")) {
        valueParaOSelect = [selectAllOption];
    } else {
        valueParaOSelect = options.filter((option) =>
            impostosSelecionados.includes(option.value)
        );
    }

    const handleChange = (selected, actionMeta) => {
        if (actionMeta.action === "select-option" && actionMeta.option.value === "*") {
            setImpostosSelecionados(["*"]);
            return;
        }

        if (!selected) {
            setImpostosSelecionados([]);
            return;
        }

        const newSelection = selected
            .filter((o) => o.value !== "*")
            .map((o) => o.value);

        setImpostosSelecionados(newSelection);
    };

    return (
        <div className="mt-4">
            <div className="mb-2">{t("biblioteca.taxesTypes")}</div>
            <Select
                value={valueParaOSelect}
                isMulti
                name="federal"
                options={allOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleChange}
                placeholder={t("biblioteca.selectTaxes")}
                noOptionsMessage={() => t("biblioteca.emptyTaxes")}
            />
        </div>
    );
}